module.exports = __webpack_public_path__ + "img/d3.82147a44.png";